import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import clsx from 'clsx';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { generateUtilityClasses } from '@mui/base';
import PenIcon from '../svg-icons/Pen';
import CalendarIcon from '../svg-icons/Calendar';
import ClockIcon from '../svg-icons/Clock';
var classes = generateUtilityClasses('PrivatePickersToolbar', ['root', 'dateTitleContainer']);
var PickersToolbarRoot = styled('div')(function (_ref) {
  var theme = _ref.theme,
    ownerState = _ref.ownerState;
  return _objectSpread({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 3)
  }, ownerState.isLandscape && {
    height: 'auto',
    maxWidth: 160,
    padding: 16,
    justifyContent: 'flex-start',
    flexWrap: 'wrap'
  });
});
var PickersToolbarGrid = styled(Grid)({
  flex: 1
});
var getViewTypeIcon = function getViewTypeIcon(viewType) {
  return viewType === 'clock' ? /*#__PURE__*/React.createElement(ClockIcon, {
    color: "inherit"
  }) : /*#__PURE__*/React.createElement(CalendarIcon, {
    color: "inherit"
  });
};
function defaultGetKeyboardInputSwitchingButtonText(isKeyboardInputOpen, viewType) {
  return isKeyboardInputOpen ? "text input view is open, go to ".concat(viewType, " view") : "".concat(viewType, " view is open, go to text input view");
}
var PickersToolbar = /*#__PURE__*/React.forwardRef(function PickersToolbar(props, ref) {
  var children = props.children,
    className = props.className,
    _props$getMobileKeybo = props.getMobileKeyboardInputViewButtonText,
    getMobileKeyboardInputViewButtonText = _props$getMobileKeybo === void 0 ? defaultGetKeyboardInputSwitchingButtonText : _props$getMobileKeybo,
    isLandscape = props.isLandscape,
    isMobileKeyboardViewOpen = props.isMobileKeyboardViewOpen,
    _props$landscapeDirec = props.landscapeDirection,
    landscapeDirection = _props$landscapeDirec === void 0 ? 'column' : _props$landscapeDirec,
    penIconClassName = props.penIconClassName,
    toggleMobileKeyboardView = props.toggleMobileKeyboardView,
    toolbarTitle = props.toolbarTitle,
    _props$viewType = props.viewType,
    viewType = _props$viewType === void 0 ? 'calendar' : _props$viewType;
  var ownerState = props;
  return /*#__PURE__*/React.createElement(PickersToolbarRoot, {
    ref: ref,
    "data-mui-test": "picker-toolbar",
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-mui-test": "picker-toolbar-title",
    color: "text.secondary",
    variant: "overline"
  }, toolbarTitle), /*#__PURE__*/React.createElement(PickersToolbarGrid, {
    container: true,
    justifyContent: "space-between",
    className: classes.dateTitleContainer,
    direction: isLandscape ? landscapeDirection : 'row',
    alignItems: isLandscape ? 'flex-start' : 'flex-end'
  }, children, /*#__PURE__*/React.createElement(IconButton, {
    onClick: toggleMobileKeyboardView,
    className: penIconClassName,
    color: "inherit",
    "data-mui-test": "toggle-mobile-keyboard-view",
    "aria-label": getMobileKeyboardInputViewButtonText(isMobileKeyboardViewOpen, viewType)
  }, isMobileKeyboardViewOpen ? getViewTypeIcon(viewType) : /*#__PURE__*/React.createElement(PenIcon, {
    color: "inherit"
  }))));
});
export default PickersToolbar;